import React, { useState } from "react";
import * as S from "./Benifits.styles";

const BenifitsUI = ({ benefits, margin }) => {
  const [items, setItems] = useState(4);
  const handleViewMore = () => {
    setItems(benefits.length);
  };

  return (
    <S.BenifitList margin={margin}>
      {(benefits?.length &&
        benefits
          .slice(0, items)
          .map(({ icon = "", subtitle = "", title = "" }, key) => (
            <li key={`benefits${key}`}>
              <img src={icon} className="iconCont" />
              {title && <p>{title}</p>}
              {subtitle && <span className="benifitTag">{subtitle}</span>}
            </li>
          ))) ||
        null}
      {benefits.length > items && (
        <div className="viewAll" onClick={handleViewMore}>
          <span className="viewAll__count">+5</span>
          <span className="viewAllText">VIEW ALL BENEFITS</span>
        </div>
      )}
    </S.BenifitList>
  );
};

export default BenifitsUI;
